import type { SlotKey } from '@/apilib';
import type { __EditorAPI } from '@/rEditor';

export type EditorAPI = __EditorAPI;

export const EditorAPIKey: SlotKey<EditorAPI> = {
  name: 'EditorAPI',
  public: true,
};
